import React from "react";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarBlank } from "@phosphor-icons/react";

/** Sélecteur de date shadcn (popover + calendrier FR). value/onChange en "YYYY-MM-DD". */
export function DatePicker({ value, onChange, testid, placeholder = "Choisir une date", className = "" }) {
  const [open, setOpen] = React.useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid}
          className={`w-full justify-start gap-2 font-normal border-[#E2E4F0] bg-white text-sm hover:bg-[#F7F5FC] ${date ? "text-[#0A0A0A]" : "text-[#64748B]"} ${className}`}>
          <CalendarBlank size={15} className="text-[#2E3192] shrink-0" />
          {date ? format(date, "dd/MM/yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={date} initialFocus
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
